import { connect } from 'react-redux';
import { push } from 'react-router-redux';

import Header from '../components/shared/header';
import Actions from '../actions';

import APP_ROUTES from '../constants/app-routes';

const mapStateToProps = (state, ownProps) => ({
    taxons: state.taxons,
    user: state.user,
    locale: state.locale,
    order: state.order,
    stores: state.stores,
    currentZone: state.zones.currentZone,
    cartState: state.cartState,
    multiCountryShipping: state.configs.multiCountryShipping,
    currentMunicipality: state.municipalities.currentMunicipality,
});
// TODO refactorizar
const distinctProducts = (products) => {
    const productsFilters = [];

    // eslint-disable-next-line no-restricted-syntax
    for (const product of products) {
        const filterCondition = productsFilters.findIndex((item) => item.id === product.id) === -1;
        if (filterCondition) {
            productsFilters.push(product);
        }
    }
    return productsFilters;
};

const fetchedProducts = (dispatch, locale) => dispatch(Actions.fetchProducts({ page_no: 1, locale })).then((response) => {
    const fetchedProducts = response.body;

    dispatch(Actions.addProducts({ products: distinctProducts(fetchedProducts.data), meta: fetchedProducts.meta }));
    dispatch(Actions.hideLoader());
});

const mapDispatchToProps = (dispatch) => ({
    goToUserOrders: () => {
        dispatch(push(APP_ROUTES.ordersPageRoute));
    },

    logout: () => {
        dispatch(Actions.logout());
        dispatch(push(APP_ROUTES.homePageRoute));
    },
    setCurrentStore: (store) => {
        dispatch(Actions.displayLoader());
        dispatch(Actions.fetchStorePayments(store)).then(() => {
            fetchedProducts(dispatch);
        }).catch((err) => console.log(err));
    },

    setCurrentZone: (zoneId) => {
        dispatch(Actions.setCurrentZone(zoneId));
    },
    emptyCart: (order, locale) => dispatch(Actions.emptyCart(order, locale)),
    loadGroupedStores: () => dispatch(Actions.loadGroupedStores()),
});

const HeaderConnector = connect(mapStateToProps, mapDispatchToProps)(Header);

export default HeaderConnector;



/** WEBPACK FOOTER **
 ** ./src/containers/header-connector.js
 **/